/**
 * withCartShipments
 * HOC for wrapping the provided component with CartShipmentsProvider
 */

import React from 'react'

import CartShipmentsProvider from './cart-shipments-provider'

export default function withCartShipments (WrappedComponent) {
  return function CartShipmentsProviderHOC(props) {
    return (
      <CartShipmentsProvider>
        <WrappedComponent {...props} />
      </CartShipmentsProvider>
    )
  }
}
